import HTTP from '@/utils/http'
import notification from '@/utils/notification'

export async function getCompany (companyId) {
  try {
    const response = await HTTP.get(`companies/${companyId}`)
    const company = response.data.data
    return company
  } catch (err) {
    notification.handleResponseError(err, 'getCompany')
    throw err
  }
}

export async function createCompany (request) {
  try {
    const response = await HTTP.post('companies', {...request})
    const company = response.data.data
    return company
  } catch (err) {
    notification.handleResponseError(err, 'createCompany')
    throw err
  }
}

export async function updateCompany (companyId, request) {
  try {
    const response = await HTTP.put(`companies/${companyId}`, {...request})
    const company = response.data.data
    return company
  } catch (err) {
    notification.handleResponseError(err, 'updateCompany')
    throw err
  }
}

export async function linkContactsToCompany (companyId, ccdContactIds) {
  try {
    const response = await HTTP.post(`companies/${companyId}/link`, ccdContactIds)
    const company = response.data.data
    return company
  } catch (err) {
    notification.handleResponseError(err, 'addCompanyContact')
    throw err
  }
}

export async function updateCompanyContacts (companyId, ccdContacts) {
  try {
    const response = await HTTP.put(`companies/${companyId}/link`, ccdContacts)
    const company = response.data.data
    return company
  } catch (err) {
    notification.handleResponseError(err, 'updateCompanyContact')
    throw err
  }
}

export async function removeContactsFromCompany (companyId, ccdContactIds) {
  try {
    await HTTP.delete(`companies/${companyId}/link`, { data: ccdContactIds })
    return true
  } catch (err) {
    notification.handleResponseError(err, 'deleteCompanyContact')
    return false
  }
}

export async function searchCompanies (query) {
  try {
    const response = await HTTP.silentGet('/companies', { params: query })
    return response.data.data || []
  } catch (err) {
    notification.handleResponseError(err, 'getCompany')
    throw err
  }
}
